import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const fallbackSlides = [
  {
    id: "fallback-home-banner",
    Image: "/images/banner-desktop.jpg",
    title: "Find Your Ideal Property",
    subtitle: "in Abu Dhabi",
    price: "",
    url: "/properties-for-sale",
  },
];

const Slider = () => {
  const [slides, setSlides] = useState(fallbackSlides);
  const [current, setCurrent] = useState(0);
  const API = process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";

  useEffect(() => {
    axios
      .get(`${API}/api/homebanner.ashx`)
      .then((res) => {
        const result = Array.isArray(res.data?.data) ? res.data.data : [];
        setSlides(result.length ? result : fallbackSlides);
      })
      .catch((err) => {
        console.error("API error:", err);
        setSlides(fallbackSlides);
      });
  }, [API]);

  useEffect(() => {
    if (slides.length === 0) return undefined;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides]);

  const changeSlide = (dir) => {
    if (slides.length === 0) return;

    let newIndex = current + dir;
    if (newIndex < 0) newIndex = slides.length - 1;
    if (newIndex >= slides.length) newIndex = 0;
    setCurrent(newIndex);
  };

  return (
    <div className="slider">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`slide ${index === current ? "active" : ""}`}
        >
          <img src={slide.Image} alt={slide.title} />
          <div className="slider-overlay" />

          <div className="slider-content">
            <h1>
              <span>{slide.title}</span>
              <span>{slide.subtitle}</span>
            </h1>
            {slide.price ? <p>{slide.price}</p> : null}
            <Link to={slide.url} className="slider-btn">
              Explore Now
            </Link>
          </div>
        </div>
      ))}

      <div className="slider-arrow left" onClick={() => changeSlide(-1)}>
        &#10094;
      </div>
      <div className="slider-arrow right" onClick={() => changeSlide(1)}>
        &#10095;
      </div>
    </div>
  );
};

export default Slider;
